document.addEventListener('DOMContentLoaded', function () {
    new Splide('#related-products', {
      perPage: 4,
      perMove: 1,
      gap: '32px',
      pagination: false,
      arrows: false,
      breakpoints: {
        1120: {
          perPage: 2,
          perMove: 1,
          gap: '32px',
          arrows: true,
          pagination: true,
          padding: { right: '12.4rem' },
        },
        767: {
          perPage: 1,
          perMove: 1,
          gap: '20px',
          arrows: true,
          pagination: true,
          padding: { right: '20%' },
        },
        430: {
            perPage: 1,
            perMove: 1,
            gap: '20px',
            arrows: true,
            pagination: true,
            padding: { right: '30%' },
          },
    },
  }).mount();
});